import { FC } from "react";
import { IconProps } from "./types";

export const PlayIcon: FC<IconProps> = ({
  fill = "currentColor",
  width = 15,
  height = 15,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
    className={className}
    {...props}
  >
    <path
      d="M10.4614 7.38475L4.30758 2.46154L4.30758 12.3077L10.4614 7.38475Z"
      fill={fill}
    />
  </svg>
);
